

import {instance} from '@/Utils/axios'

export default {
  // EBS配方执行数据
  getEBSList: params => instance.post('/nhf-app/ebsformulaexec/pageEbsFormulaExecVO', params),
  ebsformulaexecpro: params => instance.get('/nhf-app/ebsformulaexecpro/list', {params}),
  ebsformulaexecraw: params => instance.get('/nhf-app/ebsformulaexecraw/list', {params}),
  
};